import * as React from 'react';

const ScanPlusFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <defs>
            <path
                id="scan-plus-fill_svg__24_small_scan_plus_fill-a"
                d="M0 0h20v20H0V0zm18 14v4h-4v1h5v-5h-1zM1 14v5h5v-1H2v-4H1zM14 1v1h4v4h1V1h-5zm-3.5 8.5H14v1h-3.5V14h-1v-3.5H6v-1h3.5V6h1v3.5zM1 1h5v1H2v4H1V1z"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(2 2)">
            <mask
                id="scan-plus-fill_svg__24_small_scan_plus_fill-b"
                fill="#fff"
            >
                <use xlinkHref="#scan-plus-fill_svg__24_small_scan_plus_fill-a" />
            </mask>
            <use
                fill="#45494E"
                xlinkHref="#scan-plus-fill_svg__24_small_scan_plus_fill-a"
            />
            <g mask="url(#scan-plus-fill_svg__24_small_scan_plus_fill-b)">
                <path fill="#000" d="M-2-2h24v24H-2z" />
            </g>
        </g>
    </svg>
);

ScanPlusFillSvg.displayName = 'ScanPlusFillSvg';
export default ScanPlusFillSvg;
